var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('div',{staticClass:"app_icon",style:(`background-image: url('${_vm.image}'); width: ${_vm.size}px; height: ${_vm.size}px;`)}):_c('div',{class:`app_icon d-flex justify-center align-center`,style:(`background: #fafafa;`)},[_c('RowIcon',{attrs:{"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }